import { startTransition, useEffect, useState } from 'react'

/**
 * True once the element comes within `rootMargin` of the viewport, and from
 * then on. Lets a heavy subtree (a film's drawing) mount a screen ahead of
 * the reader instead of on page load; the update is a transition, so it never
 * blocks input.
 *
 * @param {{ current: Element | null }} ref
 * @param {string} [rootMargin]
 * @returns {boolean}
 */
export default function useNearViewport(ref, rootMargin = '100% 0px') {
  const [near, setNear] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (near || !el) return undefined
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return
        observer.disconnect()
        startTransition(() => setNear(true))
      },
      { rootMargin },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [ref, rootMargin, near])

  return near
}
